
const usersLengthMessage = (array, windowWidth) => {
    const usersLength = array.length;
    const isMobile = windowWidth <= 768;

    if (usersLength === 0) {
        return `No Invoices`;
    } else if (usersLength === 1) {
        if (isMobile) {
            return '1 user';
        } else {
            return `There is 1 user`;
        }
    } else if (usersLength > 1) {
        if (isMobile) {
            return `${usersLength} users`;
        } else {
            return `There are ${usersLength} users`;
        }
    }
}

export default usersLengthMessage;
